import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["numberInput", "formattedNumber", "percentage", "warning"]
  static values = { fundSize: Number }

  connect() {
    // Set initial checkbox state when controller connects
    const darkMode = localStorage.getItem('dark') === 'true';
    const dashboardDarkModeCheckbox = document.getElementById('toggle_dark_mode_checkbox');
    if (dashboardDarkModeCheckbox) {
      dashboardDarkModeCheckbox.checked = darkMode;
    }

    // Format initial value if present
    if (this.hasNumberInputTarget && this.hasFormattedNumberTarget) {
      this.formatNumber()
    }
  }

  toggleDarkMode(event) {
    event.preventDefault();
    event.stopPropagation();

    const html = document.querySelector("html");
    html.classList.toggle("dark");
    const isDark = html.classList.contains("dark");
    localStorage.setItem("dark", isDark);

    // Update icon states
    const themeToggleDarkIcon = document.getElementById('themeToggleDarkIcon');
    const themeToggleLightIcon = document.getElementById('themeToggleLightIcon');

    if (themeToggleDarkIcon && themeToggleLightIcon) {
      if (isDark) {
        themeToggleLightIcon.classList.remove('hidden');
        themeToggleDarkIcon.classList.add('hidden');
      } else {
        themeToggleDarkIcon.classList.remove('hidden');
        themeToggleLightIcon.classList.add('hidden');
      }
    }

    // Update dashboard checkbox if it exists
    const dashboardDarkModeCheckbox = document.getElementById('toggle_dark_mode_checkbox');
    if (dashboardDarkModeCheckbox) {
      dashboardDarkModeCheckbox.checked = isDark;
    }
  }

  formatNumber() {
    if (!this.hasNumberInputTarget || !this.hasFormattedNumberTarget) return

    const value = parseFloat(this.numberInputTarget.value) || 0

    // Format with commas and currency symbol
    const formatted = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value)

    this.formattedNumberTarget.textContent = formatted

    // Calculate and display percentage if fund size is provided
    if (this.hasPercentageTarget && this.hasFundSizeValue && this.fundSizeValue > 0) {
      const percentage = (value / this.fundSizeValue) * 100
      this.percentageTarget.textContent = percentage.toFixed(2) + '%'

      // Show warning if exceeds fund size
      if (this.hasWarningTarget) {
        if (value > this.fundSizeValue) {
          this.warningTarget.classList.remove('hidden')
        } else {
          this.warningTarget.classList.add('hidden')
        }
      }
    }
  }
}
